import {FieldConfig} from '../../../models/field-config';
import {FieldType} from '../../../models/field-type';
import {OfferModificationsService} from '../../../../core/services/impl/offer-modifications/offer-modifications.service';

export class AcVariantsSectionConfigBase {

    constructor(public offerModificationsService: OfferModificationsService) {

    }

    createVehicleValueFieldConfig(): FieldConfig | null {
        if (this.offerModificationsService.vehicleValueModificationEnabled) {
            return {
                fieldKey: 'vehicleValue',
                type: FieldType.NumberStepInput,
                caption: 'SELECTED_OFFER_COMPONENT.vehicleValue',
                readonly: true,
                numberStepInputConfig: {
                    step: 1000,
                    inputSuffix: 'OFFER_SECTION.SHARED.currencyShortcut'
                },
                properties: {
                    mobileInputType: 'tel',
                    textTransform: {
                        type: 'separateAndConvertToNumber',
                        separatorConfig: {
                            charsChain: 3,
                            separator: ' '
                        }
                    },
                }
            };
        }
        return null;
    }
}
